import { Button } from "@components/buttons/button";
import { Card } from "@components/cards/card";
import { IRaffleDefaultDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { Masks } from "@hooks/functions/Masks/Masks";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { useEffect, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

interface IProps {
  raffle: IRaffleDefaultDTO;
  raffleKey: string;
  selectedTickets: string[];
  values: {
    priceGross: number;
    discount: number;
    price: number;
  };
  visibilityStatus?: boolean;
}

const masks = new Masks();
export function RaffleDefaultFloatOfferBox({
  raffle,
  raffleKey,
  selectedTickets,
  values,
  visibilityStatus = false,
}: IProps) {
  // Main PlugIns, Attr, etc...
  const navigate = useNavigate();
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  // State Control
  const [visible, setVisible] = useState<boolean>(false);
  const setFloatBoxVisibility = () => {
    setVisible(!visible);
  };

  const buyTicket = () => {
    navigate(`/raffle/checkout`, {
      state: {
        raffle,
        raffleKey,
        campaign: raffle.campaign,
        selectedTickets,
      },
    });
  };

  useEffect(() => {
    setVisible(visibilityStatus);
  }, [visibilityStatus]);

  return (
    <>
      <div
        style={{
          position: "fixed",
          bottom: "25px",
          right: "30px",
          zIndex: 9999,
          borderRadius: "8px",
          minWidth: "150px",
          maxWidth: "250px",
        }}
      >
        <Card>
          <div
            className="card-header py-2 d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setFloatBoxVisibility();
            }}
          >
            <span className="fw-bold">Resumo</span>
            {visible ? <FiEyeOff /> : <FiEye />}
          </div>
          <div className={`card-body pt-2 ${visible ? `` : `d-none`}`}>
            {/* Offer Info */}
            <div className="row mb-2">
              <div className="d-flex justify-content-between">
                <span>
                  Selecionado{(selectedTickets.length || 0) > 1 ? `s` : ``}:
                </span>
                <span>{masks.formatMilhar(selectedTickets.length || 0)}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Preço Bruto:</span>
                <span>{masks.brlCurrency(values?.priceGross || 0)}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Desconto:</span>
                <span>-{masks.brlCurrency(values?.discount || 0)}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Total à Pagar:</span>
                <span>{masks.brlCurrency(values?.price || 0)}</span>
              </div>
            </div>

            {/* Button */}
            <div className="d-flex justify-content-center">
              <Button
                type="button"
                className="btn btn-success w-100"
                onClick={() => buyTicket()}
              >
                Finalizar
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
}
